export const DEFAULT_ACTIVATION_STATE = {
  currentStep: 1,
  step1: {
    targetMonthlyCashflowGross: '',
    targetExitNetWorth: '',
    timeframeYears: '',
    availableCapital: '',
    jvCapitalAccess: '',
    executionScore: null,
    targetsLocked: false,
    askRobConversation: [],
  },
  step2: {
    operatingPreference: '',
    primaryStrategy: '',
    secondaryStrategy: null,
    strategyLocked: false,
    strategyLockedAt: null,
    strategyAttributes: {
      deliveryIntensity: null,
      returnRealisationSpeed: null,
      complexityRating: null,
      dealBias: null,
    },
    primaryFocusRatio: null,
    secondaryFocusRatio: null,
    selectionRationale: null,
  },
  step3: {
    preferredLocation: '',
    maxTravelValue: '',
    travelUnit: 'miles',
    selectedPostcodes: [],
    selectedMarketId: null,
    postcodeRecommendationsMarketId: null,
    selectedPostcodeTargets: [],
    areaSuggestions: null,
    areaMarketAnalysis: null,
    areaRecommendations: null,
  },
  step4: { marketData: {}, marketScanRun: null, microscapes: [], unitTypes: [] },
  step5: { primaryMetric: '', primaryThreshold: '', secondaryMetric: '', secondaryThreshold: '' },
}
